export default __webpack_public_path__ + "static/gallery16-85f770174f23ec9f24bfb72fc2be4652.png";